import React, { useState } from "react";
import emailjs from 'emailjs-com';
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import LogoImage from "images/logo-light.svg";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-9.svg";

const Container = tw.div`relative bg-primary-500 text-gray-100 -mb-8 -mx-8 px-8 py-10 lg:py-10`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const FiveColumns = tw.div`flex flex-wrap text-center sm:text-left justify-center sm:justify-start md:justify-between -mt-12`;

const Column = tw.div`px-4 sm:px-0 sm:w-1/3 md:w-auto mt-12`;
const ColumnHeading = tw.h5`uppercase font-bold`;

const LinkList = tw.ul`mt-6 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:border-gray-100 pb-1 transition duration-300`;

const Divider = tw.div`my-16 border-b-2 border-primary-400 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-xl font-black tracking-wider text-gray-100`;

const CopywrightNotice = tw.p`text-center text-xl sm:text-base mt-8 md:mt-0 font-bold text-gray-400`;

const SocialLinksContainer = tw.div`mt-8 md:mt-0 flex`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-100 text-gray-900 hover:bg-gray-400 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

const AddressContainer = tw.div`mt-12 flex flex-col items-center text-center sm:items-start sm:text-left`;
const Address = tw.p`text-sm sm:text-base text-gray-400 mt-2`;

const MapContainer = tw.div`mt-12 mb-12 flex justify-center w-full h-64 rounded-lg overflow-hidden`;
const MapIframe = tw.iframe`w-full h-full border-none`;

const FormContainer = tw.div`mt-16 mb-16 max-w-screen-lg mx-auto bg-white p-8 rounded-lg shadow-lg text-black`;
const FormHeading = tw.h2`text-2xl font-bold text-center text-gray-900 mb-4`;
const Form = tw.form`mt-8 flex flex-wrap justify-between`;
const FormColumn = styled.div`
  ${tw`w-full md:w-5/12 pr-4`}
`;
const MessageColumn = styled.div`
  ${tw`w-full md:w-7/12 pl-4 flex flex-col justify-between`}
`;
const FormGroup = tw.div`mb-4`;
const Label = tw.label`block text-sm font-semibold mb-2 text-gray-700`;
const Input = tw.input`w-full px-4 py-2 text-base bg-white border border-gray-300 rounded-md focus:outline-none focus:border-primary-500`;
const Textarea = tw.textarea`w-full px-4 py-2 text-base bg-white border border-gray-300 rounded-md focus:outline-none focus:border-primary-500 h-32 resize-none`;
const SubmitButton = styled.button`
  ${tw`mt-4 py-3 bg-primary-500 text-white text-lg font-semibold rounded-md hover:bg-primary-700 transition duration-300`}
  width: 200px; /* Set the button width */
  align-self: center; /* Center the button horizontally */
`;

const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`;
const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute top-0 left-0 w-80 h-80 transform -translate-x-20 -translate-y-32 text-primary-700 opacity-50`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob1
)`absolute bottom-0 right-0 w-80 h-80 transform  translate-x-32 translate-y-48 text-primary-700 opacity-50`;

export default () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });
  const [notification, setNotification] = useState("");
  const [mobileError, setMobileError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^[0-9]{10}$/;
    return mobileRegex.test(mobile);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateMobile(formData.mobile)) {
      setMobileError("Please enter a valid 10-digit mobile number.");
      return;
    }
    setMobileError("");

    emailjs.send(
      'service_nsawtsa', // Replace with your EmailJS service ID
      'template_m7qabam', // Replace with your EmailJS template ID
      formData,
      'RLtwEKUzYfUxR0RkJ' // Replace with your EmailJS public key
    )
    .then((response) => {
      setNotification('Message sent successfully!');
      console.log('SUCCESS!', response.status, response.text);
    }, (err) => {
      setNotification('Failed to send message. Please try again.');
      console.log('FAILED...', err);
    });
  };

  return (
    <Container>
      <Content>
        <FiveColumns>
          <Column>
            <ColumnHeading>Main</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#">Blog</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">FAQs</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Support</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">About Us</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Product</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#">Log In</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Personal</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Business</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Team</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Press</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#">Logos</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Events</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Stories</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Office</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Legal</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#">GDPR</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Privacy Policy</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Terms of Service</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Disclaimer</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Contact</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#">info@99corporates.com</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">+91-9408486330</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Ahmedabad</Link>
              </LinkListItem>
            </LinkList>
          </Column>
        </FiveColumns>
        <Divider />
        <FormContainer id="contact">
          <FormHeading>Contact Us</FormHeading>
          <p>We would love to talk to you about any new projects you may have or any of the services that we offer. We appreciate your interest in our services! Please fill in the form below, and we will reply to you soon. You can also call or write to us.</p>
          
          <Form onSubmit={handleSubmit}>
            <FormColumn>
              <FormGroup>
                <Label htmlFor="name">Name</Label>
                <Input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="mobile">Mobile</Label>
                <Input type="text" id="mobile" name="mobile" value={formData.mobile} onChange={handleChange} required />
                {mobileError && (
                  <div style={{ color: "red", marginTop: "5px" }}>{mobileError}</div>
                )}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="email">Email</Label>
                <Input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="subject">Subject</Label>
                <Input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required />
              </FormGroup>
            </FormColumn>
            <MessageColumn>
              <FormGroup>
                <Label htmlFor="message">Message</Label>
                <Textarea id="message" name="message" value={formData.message} onChange={handleChange} required />
              </FormGroup>
              <SubmitButton type="submit">Send Message</SubmitButton>
              {notification && (
            <div
              style={{
                backgroundColor: notification.includes("successfully") ? "green" : "red",
                width: "50%",
                alignSelf: "center",
                color: "white",
                padding: "10px",
                borderRadius: "5px",
                marginBottom: "10px",
                textAlign: "center",
              }}
            >
              {notification}
            </div>
          )}
            </MessageColumn>
          </Form>
        </FormContainer>
        <AddressContainer>
          <ColumnHeading>AHMEDABAD Address:</ColumnHeading>
          <Address>
            B/806, ASHIMA TOWERS, OPPOSITE SANDESH PRESS, VASTRAPUR, AHMEDABAD – 380054 GUJARAT, INDIA
          </Address>
          <Address>E-Mail - info@99corporates.com</Address>
        </AddressContainer>
        <MapContainer>
          <MapIframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.5455290357695!2d72.52169797392517!3d23.04045331566334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84b40c9c023f%3A0x1a026613db4134d6!2sDATALIGENCE%20INFOTECH%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1720506368254!5m2!1sen!2sin"
            allowfullscreen=""
            loading="lazy"
            // loading="eager"

          ></MapIframe>
        </MapContainer>
        <ThreeColRow>
          {/* <LogoContainer>
            <LogoText>DATALIGENCE INFOTECH PRIVATE LIMITED.</LogoText>
          </LogoContainer> */}
          <CopywrightNotice>&copy; 2024 DATALIGENCE INFOTECH PRIVATE LIMITED. All Rights Reserved.</CopywrightNotice>
          <SocialLinksContainer>
            <SocialLink href="https://facebook.com">
              <FacebookIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://youtube.com">
              <YoutubeIcon />
            </SocialLink>
          </SocialLinksContainer>
        </ThreeColRow>
      </Content>
      <DecoratorBlobContainer>
        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </DecoratorBlobContainer>
    </Container>
  );
};
